import { render, staticRenderFns } from "./App.vue?vue&type=template&id=650d771e"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=650d771e&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports